import React from 'react'
import Footers from './Footer'
import Navbar from './Navbar'
import { motion } from "framer-motion";

const SlidingBedroomWardrobes = () => {
  return (
    <motion.div    className="page-wraper"
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }} style={{ background: '#fff' }}>
    
    <Navbar />
    <div className="page-content" >
      {/* <!-- CONTENT START --> */}
      <div className="page-content">
        {/* <!-- INNER PAGE BANNER --> */}
        <div
          className="wt-bnr-inr overlay-wraper bg-parallax bg-top-center"
          data-stellar-background-ratio="0.5"
          style={{
            backgroundImage: "url(assets/pic/bedroom-header.jpg)",
          }}
        >
          <div className="overlay-main bg-black opacity-07"></div>
          <div className="container">
            <div className="wt-bnr-inr-entry">
              <div className="banner-title-outer">
                <div className="banner-title-name">
                  <h2 className="text-white" >
                  Sliding Bedroom Wardrobes
                  </h2>
                </div>
              </div>
              {/* <!-- BREADCRUMB ROW -->  */}

              <div>
                <ul className="wt-breadcrumb breadcrumb-style-2">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>fitted wardrobes</li>
                  <li>Sliding Wardrobes</li>
                  <li>Sliding Bedroom Wardrobes</li>
                </ul>
              </div>

              {/* <!-- BREADCRUMB ROW END --> */}
            </div>
          </div>
        </div>
        {/* <!-- INNER PAGE BANNER END --> */}

        {/* <!--  SECTION START --> */}
        <div className="section-full p-t80 p-b80  overflow-hide" style={{background:'#fff'}}>
          <div className="container">
            <div className="section-content">
              <div className="row">
                <motion.div
                                    initial={{ opacity: 0, x: -50 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1 }} className="col-lg-6 col-md-12">
                  <div className="arc-home-about-left">
                    <div className="arc-home-left-content  " style={{background:'#fff'}}>
                      <h3 className="m-t0 wt-tilte-light" style={{color:'#B19777'}}>
                      Fitted Wardrobes For Beautiful Bedrooms
                      </h3>
                      <p>
                      A well-designed bedroom is incomplete without a fitted wardrobe that enhances both style and practicality. Custom-built to suit your space, these wardrobes offer seamless storage solutions while complementing your bedroom’s décor. From sleek sliding doors to classic hinged designs, fitted wardrobes provide ample space for clothing, accessories, and personal belongings, ensuring a clutter-free and organized room.
                      </p> 
                     
                      <a 
  href="" 
  className="site-button-link" 
  style={{
    background: '#B19777',
    color: 'white',
    padding: '18px',
    textDecoration: 'none',
    border: '2px solid #B19777',
    transition: 'all 0.3s ease-in-out'
  }}
  onMouseEnter={(e) => {
    e.target.style.background = 'white';
    e.target.style.color = '#B19777';
  }}
  onMouseLeave={(e) => {
    e.target.style.background = '#B19777';
    e.target.style.color = 'white';
  }}
> 
  Read More
</a>
                    </div>
                  </div>
                </motion.div>

                <motion.div
                                    initial={{ opacity: 0, x: 50 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    transition={{ duration: 1 }} className="col-lg-6 col-md-12">
                  <div className="arc-home-about-right portfolio-wrap">
                    <div className="row">
                      <div className="col-md-6 col-sm-6 masonry-item">
                        <div className="wt-media m-b20  img-reflection">
                          <img src="/assets/pic/bedbeauty (1).jpg" alt="" />
                        </div>
                      </div>

                      <div className="col-md-6 col-sm-6 masonry-item">
                        <div className="wt-media m-b20  img-reflection">
                          <img src="/assets/pic/bedbeauty2 (1).jpg" alt="" />
                        </div>
                      </div>

                      <div className="col-md-6 col-sm-6 masonry-item">
                        <div className="wt-media m-b20  img-reflection">
                          <img src="/assets/pic/bedbeauty1 (1).webp" alt="" />
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-6 masonry-item">
                        <div className="wt-media m-b20  img-reflection">
                          <img src="/assets/pic/bedbeauty3 (1).jpg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </div>
            </div>
          </div>
        </div>
        {/* <!--   SECTION END -->   */}

         {/* <!--  SECTION START --> */}
         {/* <div className="section-full p-t80 p-b80 bg-gray overflow-hide">
          <div className="container">
            <div className="section-content">
              <div className="row">
               

                <div className="col-lg-6 col-md-12">
                  <div className="arc-home-about-right portfolio-wrap">
                    <div className="row">
                      <div className="col-md-6 col-sm-6 masonry-item">
                        <div className="wt-media m-b20  img-reflection">
                          <img src="assets/images/about/l-2.jpg" alt="" />
                        </div>
                      </div>

                      <div className="col-md-6 col-sm-6 masonry-item">
                        <div className="wt-media m-b20  img-reflection">
                          <img src="assets/images/about/l-2.jpg" alt="" />
                        </div>
                      </div>

                      <div className="col-md-6 col-sm-6 masonry-item">
                        <div className="wt-media m-b20  img-reflection">
                          <img src="assets/images/about/s-3.jpg" alt="" />
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-6 masonry-item">
                        <div className="wt-media m-b20  img-reflection">
                          <img src="assets/images/about/s-3.jpg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-12">
                  <div className="arc-home-about-left">
                    <div className="arc-home-left-content  bg-gray">
                      <h3 className="m-t0 wt-tilte-light">
                      No installation problems
                      </h3>
                      <p>
                      When investing in a fitted wardrobe, the last thing you want is a complicated installation process. With expertly crafted sliding and fitted wardrobes, you get a seamless and hassle-free setup, ensuring that your new storage solution is installed efficiently and without disruption. Designed to fit perfectly into your space, these wardrobes eliminate the need for additional modifications, making the process smooth and stress-free.
                      </p> 
                     
                      <a
                        href=""
                        className="site-button-link"
                        style={{
                          background: "#141b1f",
                          color: "white",
                          padding: "18px",
                        }}
                      >
                        Read More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* <!--   SECTION END -->   */}
       
      </div>
      {/* <!-- CONTENT END --> */}
    </div>
    <Footers />
    {/* <!-- BUTTON TOP START --> */}
    <button className="scroltop">
      <span className="fa fa-angle-up  relative" id="btn-vibrate"></span>
    </button>
  </motion.div   >
  )
}

export default SlidingBedroomWardrobes
